import {
  UPDATE_EMAIL,
  UPDATE_PASSWORD,
  ON_LOGGEDIN,
  SET_USER_PROFILE,
} from "../actions/LoginAction";
import { keyBy } from 'lodash';

const initialState = {
  email: "",
  password: "",
  isLoggedin: localStorage.getItem('token') ? true : false,
  user: {},
  permissions: {},
  permissionsMap: new Map(),
  isProfileFetched: false
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_EMAIL: {
      return {
        ...state,
        email: action.payload,
      };
    }

    case UPDATE_PASSWORD: {
      return {
        ...state,
        password: action.payload,
      };
    }

    case ON_LOGGEDIN: {
      return {
        ...state,
        isLoggedin: action.payload,
      };
    }

    case SET_USER_PROFILE: {
      const permissionsMap = keyBy(action.payload.permissions, 'permissionAssignedId');
      return {
        ...state,
        user: action.payload.user,
        permissions: action.payload.permissions,
        admin: action.payload.admin,
        isProfileFetched: true,
        permissionsMap
      }
    }

    default:
      return state;
  }
};

export default loginReducer;
